<template>
  <el-dialog v-loading="dialogLoading" title="选择人员" :visible.sync="visible" width="70%" center :close-on-click-modal="false">
    <div class="select-box">
      <div class="box-left fl">
        <!-- <el-select  class="mt15" style="width:100%" v-model="tenantGuid" filterable  placeholder="请选择公司">
          <el-option v-for="item in sendTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
          </el-option>
        </el-select> -->
        <el-input v-model="filterText" class=" mt15" placeholder="请输入名称"></el-input>
        <p class="fontC-bbb">组织架构</p>
        <el-tree
          class="filter-tree"
          :data="areaData"
          :props="defaultProps"         
          node-key="staffGuid"
          :filter-node-method="filterNodeDep"
          ref="treeDep"
          check-on-click-node  
          @node-click="handleNodeClick"
        >
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <!-- <img v-if="data.nodeType == 1" src="../../../assets/images/ico_ora.png" alt="" />
            <img v-else src="../../../assets/images/icon_per.png" alt="" />
            <span>{{ data.name }}</span> -->
            <img :src="data.icon" alt="" />
              <!-- <img src="../../assets/images/icon_per.png" alt=""> -->
              <span>{{ data.label }} <span class="remark-class" v-if="data.remark">（{{ data.remark }}）</span></span>
          </div>
        </el-tree>
      </div>
      <div class="box-right fr">
        <p class="fontC-bbb fl">已选{{ departmentList.length }}个成员</p>
        <!-- <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
          >批量删除
        </el-button> -->
        <el-table
          :data="departmentList"
          border
          height="280px"
          style="width: 100%"
        >
        <!-- @selection-change="handleSelectionChangeDel" -->
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column header-align="center" align="center" show-overflow-tooltip prop="label" label="名称">
            <!-- <template slot-scope="scope">
                {{ scope.row.label||scope.row.guid }}
              </template> -->
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer t-right">
      <el-button plain size="medium" @click="visible = false">取消</el-button>
      <el-button size="medium" type="info" @click="addAButton">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  // props:['tenantGuid'],
  data() {
    return {
      dialogLoading:false,
      defaultProps: {
        id: 'staffGuid',
        // id: 'userGuid',
        label: 'name',
        children: 'children',
        disabled: this.disabledTreeNode,
      },

      visible: false, //部门人员弹框
      defaultCheckedKeys: [],
      area: [],
      departmentList: [], //选中的部门人员数据
      departmentData: '',
      areaData: [], //人员部门数据
      delList: [],
      personGuidList: [], //选中的人员guid
      filterText: '',
      fullscreenLoading: false,
      sendTenantList: [],
      sendTenantGuid:'',
      sendTenantName:'',

      tenantGuid:'',
      tenantName:'',
      index:null,
      staffType:''
    };
  },
   watch: {
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
    // tenantGuid(val){
    //   // this.sendTenantList.forEach(i=>{
    //   //   if(i.guid==val){
    //   //     this.tenantName=i.tenantName
    //   //   }
    //   // })
    //   // console.log('this.tenantName',this.tenantName);
      
    //   this.getOrganisation(val)
    //   this.$nextTick(() => {
    //     this.$refs.treeDep.setCheckedKeys([]);
    //   });
     
    // }
  },
  created() {
    // this.getSendTenantList()
  },
  methods: {
    open(personGuidList,tenantGuid,index,type) {
      this.filterText=''
      console.log('open',personGuidList);
      this.staffType=type
      // this.index=null
      // if(index ||index==0) this.index=index
      this.personGuidList = personGuidList;
      // this.departmentList=this.personGuidList
      // this.tenantGuid=tenantGuid || localStorage.guid
      // this.tenantGuid=tenantGuid 
      this.tenantGuid=localStorage.guid 

      this.visible = true;
      this.dialogLoading = true;
      this.areaData = [];
      // this.sendTenantList.forEach(i=>{
        
      //   if(i.guid==localStorage.guid){
      //     this.tenantName=i.tenantName
      //     console.log('099', this.tenantName);
          
      //   }
      // })
      console.log('personGuidList',this.personGuidList);
      this.getOrganisation(this.tenantGuid);
      // this.$nextTick(()=>{
      //   this.$nextTick(() => {
      //   this.$refs.treeDep.setCheckedKeys(this.personGuidList);
      //   // this.$nextTick(()=>{
      //   //   this.departmentList = this.$refs.treeDep.getCheckedNodes();
      //   //   console.log('内',this.departmentList);
      //   // })
      //   this.departmentList = this.$refs.treeDep.getCheckedNodes();
      //   this.$forceUpdate()
      //   console.log('departmentList',this.departmentList);
        
      // });
      // })
      
    },
    // 获取公司
    // getSendTenantList() {
      
    //   let self = this;
    //   self.api
    //     .get(`/${serverConfig.msCustomerService}/tenant/data/get-service-and-tenant-list`)
    //     .then((res) => {
    //       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //         self.sendTenantList = res.data.data;
    //         if (!self.$route.query.guid && self.sendTenantList.length == 1) {
    //           self.sendTenantName = self.sendTenantList[0].tenantName;
    //           self.sendTenantGuid = self.sendTenantList[0].guid;
    //           self.tenantGuid = self.sendTenantList[0].guid;
    //           // self.getOrganisation(self.sendTenantGuid);
    //           // self.getOrganisationII(self.sendTenantGuid);
    //         }
    //       } else {
    //         self.$message.error(res.data.msg);
    //       }
    //     });
    // },
    //获取组织
    getOrganisation(guid) {
      let self = this;
      let query = {
        tenantGuid: guid,
        // isTask: 'Y',
      };
      if(this.staffType){
        query.staffType=this.staffType
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get-tree-extend`, query).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.areaData = res.data.data;
          this.treeData(this.areaData);
          self.$forceUpdate()
          
            this.$nextTick(() => {
              this.$refs.treeDep.setCheckedKeys(this.personGuidList,true);
              console.log('999',this.personGuidList,this.$refs.treeDep.getCheckedKeys());
              
              this.departmentList = this.$refs.treeDep.getCheckedNodes(true);             
              // this.departmentList = this.personGuidList
              this.$forceUpdate()
              this.dialogLoading = false;
              console.log('departmentList',this.departmentList);
              
            });
          
          console.log( self.areaData)
        } else {
          this.dialogLoading = false;
          self.$message.error(res.data.msg);
          self.areaData = [];
        }
      });
    },
    treeData(areaData) {
      const fn = (tree) => {
        tree.forEach(async (k) => {
          if (k.nodeType == 1) {//只选人员
            k.disabled = true;
          }
          k.label = `${k.name}${k.mobileNo || ''}`;
          k.staffName = k.name;
          k.mobileNo = k.mobileNo;
          k.id = k.guid;
          k.staffGuid = k.userGuid||k.guid;
          k.userGuid = k.userGuid;
          // k.staffGuid = k.guid;
          k.bizState = 'Y' // !默认有效
          k.icon = k.nodeType === '2' ? require('@/assets/images/icon_per.png') : require('@/assets/images/ico_ora.png');
          // 根据id获取人员数据,(注意转为树类型)
          if (k) {
            k.staffList = [];
            if (k.staffs) {
              k.staffs.forEach((d) => {
                let item = {
                  usertype: 1,
                  bizState:'Y', // !默认有效
                  id: d.guid,
                  staffGuid: d.userGuid||d.guid,
                  userGuid: d.userGuid,
                  label: d.staffName + d.mobileNo,
                  //下面数据是我自己加上的,发请求需要
                  mobileNo: d.mobileNo,
                  staffName: d.staffName,
                  tenantGuid: d.tenantGuid,
                  organisationNames: '123',
                  positionName: '123',
                  roleNames: '123',
                  logonUser: '123',
                  icon: require('@/assets/images/icon_per.png'),
                };
                k.staffList.push(item);
              });
            }
            const person = k.staffList;
            const isValid = (val) => {
              return val && val !== null && JSON.stringify(val) !== '[]';
            };
            // 将人员数据拼接到chilren里面
            if (k.children) {
              fn(k.children);
              isValid(person) && (k.children = [...k.children, ...person]);
              // 有子元素，需要调用自身
            } else {
              isValid(person) && (k.children = person);
            }
          }
        });
      };
      fn(areaData);
    },
    //禁用 子级选了父级禁用，父级选了子级禁用
    disabledTreeNode(data, node) {
      let list = this.departmentList;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids ? list[i].parentGuids : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex(one => {
        return one == guid;
      });
      return flag == -1 ? 0 : 1;
    },
    handleNodeClick(data){
      console.log('data',data);
      let departmentList = [data].filter((item) => item.nodeType !== '1'&&item.userGuid)
      console.log('departmentList',departmentList);
      
      this.departmentList = departmentList
      
    },
    //部门弹框选择
    // handleNodeClickPerson(data, checked, node) {
    //   this.departmentList = this.$refs.treeDep.getCheckedNodes();
    //   console.log('909',this.departmentList);
      
    // },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    addAButton() {
      console.log('888',this.departmentList);
      if(this.departmentList.length==1){
        this.$emit('onSelect', this.departmentList[0])
        this.visible = false;
      }else{
        this.$message.error('请勾选数据！');
      }
      
      // console.log('this.tableData',this.tableData);
      
      
      
    },
    //确定选择部门
    // departmentSure() {
    //   this.personGuidList = (this.departmentList || []).map(k => k.guid);
    //   this.departmentData = this.departmentList;
    //   if(this.personGuidList.length==0&&this.departmentData.length==0){
    //     this.$message.error('请选择执行对象！');
    //     return;
    //   }
    //   this.departmentData.forEach(i=>{
    //     i.tenantGuid=this.tenantGuid
    //     i.tenantName=this.tenantName
    //   })
    //   this.tenantGuid=''
    //   this.tenantName=''
    //   this.filterText=''
    //   this.$emit('onSelect', [this.personGuidList, this.departmentData,this.index]);
    //   this.visible = false;
    // },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选数据！');
        return;
      }
      // this.departmentList = this.$refs.treeDep.getCheckedNodes();
      let newArr = [];
      newArr = this.departmentList.filter(item => this.delList.every(one => one.guid !== item.guid));
      // this.$refs.treeDep.setCheckedNodes(newArr); //设置树组件的选中
    },

    handleSelectionChangeDel(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
  },
};
</script>

<style scoped>
/* 选择人员弹框 */
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 400px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 400px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 0 !important;
}
</style>
